import React from 'react';
import { createBrowserRouter, RouterProvider, createRoutesFromElements, Route } from 'react-router-dom';
import { StyledEngineProvider } from '@mui/material/styles';
import Bootstrap from './Bootstrap';

const router = createBrowserRouter(createRoutesFromElements(<Route path="/*" element={<Bootstrap />} />));

const Root = () => {
    return (
        <StyledEngineProvider injectFirst>
            <RouterProvider router={router} />
        </StyledEngineProvider>
    );
};

export default Root;
